export default __webpack_public_path__ + "static/media/kw_icon.fba5d83a.svg";